
import { Enum } from "./Enum.js";


export const CameraMode = {
	ORTHOGRAPHIC: 0,
	PERSPECTIVE: 1,
	VR: 2,
};

// 多边形棱柱（YDPolygonVolume）单柱顶点上限。必须与 pointcloud.vs 的
// #define max_clip_prism_vertices 保持一致；shader 循环按 uClipPrismVCount
// 实际数量提前 break，上限只影响 uniform 显存占用（8 柱 × 32 × vec3 = 256 向量），
// 不影响逐点计算量。
export const MAX_CLIP_PRISM_VERTICES = 32;

export const ClipTask = {
	NONE: 0,
	HIGHLIGHT: 1,
	SHOW_INSIDE: 2,
	SHOW_OUTSIDE: 3
};

export const ClipMethod = {
	INSIDE_ANY: 0,
	INSIDE_ALL: 1
};

export const ElevationGradientRepeat = {
	CLAMP: 0,
	REPEAT: 1,
	MIRRORED_REPEAT: 2,
};

export const MOUSE = {
	LEFT: 0b0001,
	RIGHT: 0b0010,
	MIDDLE: 0b0100
};

export const PointSizeType = {
	FIXED: 0,
	ATTENUATED: 1,
	ADAPTIVE: 2
};

export const PointShape = {
	SQUARE: 0,
	CIRCLE: 1,
	PARABOLOID: 2
};

export const TreeType = {
	OCTREE: 0,
	KDTREE: 1
};

export const LengthUnits = {
	METER: { code: 'm', unitspermeter: 1.0 },
	FEET: { code: 'ft', unitspermeter: 3.28084 },
	INCH: { code: '\u2033', unitspermeter: 39.3701 }
};

export const ShowMode = {
	PointClouds: 0,
	GaussianSplats: 1,
	ALL: 2
};